import { getToken } from '../../api/modules/meteo'
import { setMeteoToken } from '../../utils/auth'

export default {
  state: {
    // 属性
    meteoToken: ''
  },
  getters: {
    meteoToken: state => state.meteoToken
  },
  mutations: {
    // set方法
    setMeteoToken (state, meteoToken) {
      state.meteoToken = meteoToken
    }
  },
  actions: {
    GET_METEO_TOKEN ({ commit }) {
      const params = {
        appId: 'JF2021011901',
        secret: 'secret'
      }
      return new Promise((resolve, reject) => {
        getToken(params).then(res => {
          const meteoToken = res.data.token
          commit('setMeteoToken', meteoToken)
          setMeteoToken(meteoToken)
          resolve(meteoToken)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
